module.exports = __webpack_public_path__ + "static/media/Marigold.dacef8a1.md";